import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, concatMap } from 'rxjs/operators';
import * as academicUnitsStatisticsActions from '../action/academic-units-statistics.actions';
import { AdministratorStatisticsService } from '../../../../../services/administrator-statistics.service';

@Injectable()
export class AcademicUnitsStatisticsEffects {
   constructor(
      private actions$: Actions,
      private administratorStatistics: AdministratorStatisticsService
   ) {}

   /**
    * Effect listening for overviewStatistics Action, when overviewStatistics is dispatched the effect with call create() from courseService.
    * In case of success response the effect it will trigger overviewStatisticsSuccess.
    * In case of Error it will trigger overviewStatisticsFailure with error property.
    */
   overviewStatistics$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(academicUnitsStatisticsActions.overviewStatistics),
         concatMap((action) => {
            return this.administratorStatistics
               .academicUnitsStatisticsOverview()
               .pipe(
                  map((data) => {
                     return academicUnitsStatisticsActions.overviewStatisticsSuccess(
                        {
                           data: data.data,
                        }
                     );
                  }),
                  catchError((error) =>
                     of(
                        academicUnitsStatisticsActions.overviewStatisticsFailure(
                           {
                              error,
                           }
                        )
                     )
                  )
               );
         })
      );
   });
}
